import Vue from 'vue'
import Vuex from 'vuex'
import rootModule from './rootModule'
import myProfile from './modules/myProfile'
import myDealer from './modules/myDealer'
import auth0 from './modules/auth0'
import mfa from './modules/mfa'

Vue.use(Vuex)

const debug = process.env.NODE_ENV !== 'production'

export default new Vuex.Store({
  state: rootModule.state,
  actions: rootModule.actions,
  getters: rootModule.getters,
  mutations: rootModule.mutations,
  modules: {
    myProfile,
    myDealer,
    auth0,
    mfa
  },
  strict: debug
})



// WEBPACK FOOTER //
// ./src/store/index.js